module.exports = __webpack_public_path__ + "static/img/168.94a9c9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/168.jpg
// module id = 83MW
// module chunks = 1